var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "idml-page-preview" }, [
    _c("p", { staticClass: "small text-muted" }, [
      _vm._v(
        "\n    Approximate preview from IDML. The imported result may differ.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "idml-page-preview__page",
        attrs: {
          viewBox: `${_vm.page.left || 0} ${_vm.page.top || 0} ${Math.max(
            _vm.page.width,
            1
          )} ${Math.max(_vm.page.height, 1)}`,
          role: "img",
          "aria-label": `Page preview for ${_vm.page.name}`,
        },
      },
      [
        _vm.previewPath
          ? _c("image", {
              attrs: {
                href: _vm.publicFileUrl(_vm.previewPath),
                x: _vm.page.left || 0,
                y: _vm.page.top || 0,
                width: Math.max(_vm.page.width, 1),
                height: Math.max(_vm.page.height, 1),
                preserveAspectRatio: "none",
              },
            })
          : _c(
              "text",
              {
                staticClass: "idml-page-preview__unavailable",
                attrs: {
                  x: (_vm.page.left || 0) + Math.max(_vm.page.width, 1) / 2,
                  y: (_vm.page.top || 0) + Math.max(_vm.page.height, 1) / 2,
                  "text-anchor": "middle",
                },
              },
              [_vm._v("Backend preview is unavailable.")]
            ),
        _vm._v(" "),
        _vm._l(_vm.layers, function (node, index) {
          return _c(
            "g",
            {
              key: node.properties.id || index,
              staticClass: "idml-page-preview__layer",
              on: {
                click: function ($event) {
                  return _vm.$emit("select", node.source)
                },
              },
            },
            [
              _c("title", [
                _vm._v(
                  _vm._s(node.name) +
                    _vm._s(
                      node.properties.image &&
                        node.properties.image.requiresUpload
                        ? " — image required"
                        : ""
                    )
                ),
              ]),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: node.left,
                  y: node.top,
                  width: Math.max(node.width, 1),
                  height: Math.max(node.height, 1),
                  fill: "transparent",
                },
              }),
              _vm._v(" "),
              _vm.selected === node.source
                ? _c("rect", {
                    attrs: {
                      x: node.left,
                      y: node.top,
                      width: Math.max(node.width, 1),
                      height: Math.max(node.height, 1),
                      fill: "none",
                      stroke: "#007bff",
                      "stroke-width": "2",
                      "pointer-events": "none",
                      "vector-effect": "non-scaling-stroke",
                    },
                  })
                : _vm._e(),
            ]
          )
        }),
        _vm._v(" "),
        _vm.selected && _vm.selected.children
          ? _c("rect", {
              attrs: {
                x: _vm.selected.left,
                y: _vm.selected.top,
                width: Math.max(_vm.selected.width, 1),
                height: Math.max(_vm.selected.height, 1),
                fill: "none",
                stroke: "#007bff",
                "stroke-width": "2",
                "pointer-events": "none",
                "vector-effect": "non-scaling-stroke",
              },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }